import { createSelector } from '@reduxjs/toolkit';
import { rootSelector } from '../root/root.selectors';

export const constantSelector = createSelector(rootSelector, state => state.constant);

export const constantMainSelector = createSelector(
  constantSelector,
  constant => constant.main.data,
);

export const apiDocsUrlSelector = createSelector(
  constantMainSelector,
  constant => constant?.apiDocsUrl || '',
);
